// Only fetch the visible hero video. Keep its poster for reduced-motion users.
const mobile = window.matchMedia('(max-width: 749px)');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
function updateHeroMedia() {
  document.querySelectorAll('[data-ea-hero-video]').forEach((video) => {
    const source = video.querySelector('source[data-src]');
    if (!source) return;
    const active = !reducedMotion.matches &&
      video.dataset.eaHeroVideo === (mobile.matches ? 'mobile' : 'desktop');
    if (active) {
      if (!source.hasAttribute('src')) {
        source.src = source.dataset.src;
        video.load();
      }
      video.play().catch(() => { /* The poster remains when autoplay is blocked. */ });
    } else if (source.hasAttribute('src')) {
      video.pause();
      source.removeAttribute('src');
      video.load();
    }
  });
}
mobile.addEventListener('change', updateHeroMedia);
reducedMotion.addEventListener('change', updateHeroMedia);
document.addEventListener('shopify:section:load', updateHeroMedia);
updateHeroMedia();
